import React, { Component } from "react"
import { Input, Button, Affix, message,Switch } from "antd"
import { observer, inject } from "mobx-react"
import MaterialModal from "app/components/normal/MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import styled from 'styled-components'
import { action } from "mobx"
import MaterialForm from "app/components/normal/MaterialForm/MaterialForm"
import MaterialFormItem from "app/components/normal/MaterialFormItem/MaterialFormItem"

const InputGroup = Input.Group

const CreateOrgBtn = styled.button`
  width: 127px;
  height: 40px;
  background: #286CAC;
  color: white;
  font-size: 14px;
  border-radius: 3px;
  cursor: pointer;
  outline: none;
  border: none;
`

@inject("auth", "store") @observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dayKey: "-1",
      createModalShowed: false
    }
  }
  componentDidMount() {
    this.props.auth.getApps()
  }

  @action
  changeSearch = (e) => {
    if (this.timer) {
      clearTimeout(this.timer)
    }
    const {
      list: { filterData }
    } = this.props.store
    const keywords = e.target.value

    this.timer = setTimeout(() => {
      this.timer = null
      this.setState({
        inputSearch: keywords,
      })
      filterData({ keywords })
    }, 300)
  }

  closeModal = (modal) => {
    this.setState({
      [modal]: false
    })
  }

  showCreateOrgModal = () => {
    this.setState({
      createModalShowed: true
    })
  }

  render() {
    const { createModalShowed } = this.state
    return (
      <Affix
        className="affix-head"
        target={() => document.getElementsByClassName("salt-pagelayout")[0]} offsetTop={50}
      >
        <div className="affix-back">
          <div className="statistics-search-bar">
            <div className="search-input">
              <InputGroup className="ant-search-input">
                <Input
                  placeholder="输入模版名称搜索"
                  size="default"
                  onChange={this.changeSearch}
                />
                <div className="ant-input-group-wrap">
                  <Button icon="search" className="ant-search-btn" size="default" />
                </div>
              </InputGroup>
            </div>
            <CreateOrgBtn
              className="create-account-btn"
              onClick={() => this.showCreateOrgModal()}
            >
              + 创建模版
            </CreateOrgBtn>
          </div>

          {createModalShowed && (
            <CreateOrgModal
              store={this.props.store}
              onClose={() => this.setState({ createModalShowed: false })}
              apps={this.props.auth.apps}
            />)
          }
        </div>
      </Affix>
    )
  }
}

@observer
class CreateOrgModal extends Component {
  confirmCreate = () => {
    const { onClose } = this.props
    const { store: { list, createOrg } } = this.props
    createOrg()
      .then(res => {
        message.success('模版创建成功')
        list.getTableData()
          .then(
            res => {
              onClose()
              list.updateTableData(res)
              list.initPageIndex()
            }
          )

      }, err => {
        message.error(err)
      })
  }

  render() {
    const { onClose } = this.props
    const { submitData, updateField } = this.props.store
    return (
      <MaterialModal
        title="创建模版"
        width={450}
        className="preview-account-create-modal"
        buttonText="确认添加"
        visible
        action={() => this.confirmCreate()}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onClose}
        />
          <MaterialFormItem
              labelText="用户ID"
              labelWidth={60}
            >
              <Input
                name="userId"
                className="createAccount-input"
                placeholder="请输入用户ID"
                value={submitData.userId}
                onChange={(evt) => updateField(evt, "userId")}
              />
          </MaterialFormItem>
          <MaterialFormItem
            labelText="模版名称"
            labelWidth={60}
          >
            <Input
              className="createAccount-input"
              placeholder="请输入模版名称"
              value={submitData.name}
              onChange={(evt) => updateField(evt, "name")}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="模版类型"
            justify="center"
          >
            <Input
              name="type"
              className="createAccount-input"
              placeholder="请输入模版类型"
              value={submitData.type}
              onChange={(evt) => updateField(evt, "type")}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="机构ID"
            justify="center"
          >
            <Input
              name="orgId"
              className="createAccount-input"
              placeholder="请输入机构ID"
              value={submitData.orgId}
              onChange={(evt) => updateField(evt, "orgId")}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="一级标题"
            justify="center"
          >
            <Input
              name="appType"
              className="createAccount-input"
              value={submitData.appType}
              placeholder="请输入一级标题"
              onChange={(evt => updateField(evt, "appType"))}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="二级标题"
            justify="center"
          >
            <Input
              name="appGroupName"
              value={submitData.appGroupName}
              className="createAccount-input"
              placeholder="请输入二级标题"
              onChange={(evt) => updateField(evt, "appGroupName")}
            />
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="模版格式"
            justify="center"
          >
            <Input
              name="format"
              value={submitData.format}
              className="createAccount-input"
              placeholder="请输入模版格式"
              onChange={(evt) => updateField(evt, "format")}
            />
          </MaterialFormItem>

          <MaterialFormItem
            labelWidth={60}
            labelText="停启状态"
            justify="center"
          >
             <div style={{width: 280}}>
                <Switch 
                 name='recordState'
                  checkedChildren="开启" 
                  unCheckedChildren="停用" 
                  // defaultChecked={submitData.get('recordState') === 0}
                  onChange={(checked) => updateField( checked ? 0 : 1,'recordState' )} // 修正 here
                />
              </div>
          </MaterialFormItem>
          <MaterialFormItem
            labelWidth={60}
            labelText="模版文本"
            justify="center"
          >
            <Input
                style={
                  {minHeight: 86, maxHeight: 200, lineHeight: '17px', 
                    fontFamily: 'PingFangSC-Regular', padding: 8 }
                }
                className="createAccount-input"
                placeholder='请输入模版文本'
                type='textarea'
                name='template'
                // value={submitData.get('template')}
                onChange={(evt) => updateField(evt,'template')}
              />
          </MaterialFormItem>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/preview/template/containers/DataHeader.js